<template>
    <div>
        <v-expansion-panels v-model="expanded" style="background-color: transparent">
            <v-expansion-panel expand>
                <v-expansion-panel-title class="v-subheader theme--light">
                    {{ $t(`filterTitles.${filter}`) }}
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <v-text-field
                        v-model="name"
                        variant="outlined"
                        hide-details
                        single-line
                        density="compact"
                        :clearable="true"
                        :placeholder="placeholder"
                    />
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-divider />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch, Emit} from 'vue-facing-decorator'

    @Component
    export class NameFilter extends Vue {
        @Prop({required: true}) filterValues
        @Prop({required: true}) filters
        @Prop() filter
        @Prop() placeholder

        name = null
        timer = null
        expanded = 0

        @Emit()
        change() {
            return {key: this.filter, value: this.name}
        }

        mounted() {
            this.name = this.filterValues[this.filter]
        }

        @Watch('name')
        onNameChange() {
            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = window.setTimeout(() => {
                this.change()
            }, 400)
        }

        get() {
            return this.filters[this.filter]
        }
    }

    export default NameFilter
</script>

<style scoped>
    :deep(.v-expansion-panel-content__wrap) {
        padding: 0;
    }
</style>
